/**
 * Internal dependencies
 */
import SpacingInputControl from './spacing-input-control';
import { ALL_SIDES, ICONS, getPresetValueFromCustomValue } from '../utils';
import { type SpacingSize } from '../../../utils';

type SeparatedInputControlsProps = {
	readonly minimumCustomValue: number;
	readonly onChange: ( values: Record< string, string | undefined > ) => void;
	readonly onMouseOut?: ( event: React.SyntheticEvent ) => void;
	readonly onMouseOver?: ( event: React.SyntheticEvent ) => void;
	readonly showSideInLabel?: boolean;
	readonly sides: ReadonlyArray< string >;
	readonly spacingSizes: Array< SpacingSize >;
	readonly type?: string;
	readonly values: Record< string, string | undefined >;
	readonly disabledSides: Record<
		'top' | 'right' | 'bottom' | 'left',
		boolean
	>;
};
export default function SeparatedInputControls( {
	minimumCustomValue,
	onChange,
	onMouseOut,
	onMouseOver,
	sides,
	spacingSizes,
	type,
	values,
	disabledSides,
}: SeparatedInputControlsProps ): JSX.Element {
	// Filter sides if custom configuration provided, maintaining default order.
	const filteredSides = sides?.length
		? ALL_SIDES.filter( ( side ) => sides.includes( side ) )
		: ALL_SIDES;

	const createHandleOnChange = ( side: string ) => ( next?: string ) => {
		// Encode the existing value into the preset value if the passed in value matches the value of one of the spacingSizes.
		const nextValues: Record< string, string | undefined > = {
			...Object.keys( values ).reduce(
				( acc: Record< string, string | undefined >, key ) => {
					acc[ key ] = getPresetValueFromCustomValue(
						values[ key ],
						spacingSizes
					);
					return acc;
				},
				{}
			),
		};

		nextValues[ side ] = next;

		onChange( nextValues );
	};

	return (
		<>
			{ filteredSides.map( ( side ) => {
				return (
					<SpacingInputControl
						key={ `spacing-sizes-control-${ side }` }
						icon={ ICONS[ side as keyof typeof ICONS ] }
						minimumCustomValue={ minimumCustomValue }
						onChange={ createHandleOnChange( side ) }
						onMouseOut={ onMouseOut }
						onMouseOver={ onMouseOver }
						side={ side }
						spacingSizes={ spacingSizes }
						type={ type }
						value={ values[ side ] }
						disabled={ disabledSides[ side ] }
					/>
				);
			} ) }
		</>
	);
}
